module.exports = __webpack_public_path__ + "img/sup_deposit_bank3.f4068e06.jpg";